import React from "react";
import "./CalculatorResults.css";
import { Typography } from "@mui/material";
import tongueOut from "../../../../../Assets/Images/tongue-out.webp";
import { resultContent } from "./data";

const CalculatorResults = () => {
  return (
    <>
      <div className=" pt-3">
        <Typography
          variant="h4"
          color="#1f1f1f"
          sx={{
            fontFamily: "'Archivo', sans-serif",
            fontWeight: 600,
            fontSize: {
              xs: "20px",
              sm: "20.4312px",
              md: "24",
              lg: "24px",
            },
            padding: "15px 0px",
          }}
        >
          Understanding Your Results
        </Typography>
        <Typography
          sx={{
            fontFamily: "'Archivo',sans-serif",
            fontSize: "16px",
          }}
        >
          {resultContent[0].heading_discription}
        </Typography>

        <div className=" mt-3">
          <Typography
            sx={{
              fontFamily: "'Archivo', sans-serif",

              fontSize: "16px",
            }}
          >
            {" "}
            <strong>1. {resultContent[0].subheadingOne} </strong>
            {resultContent[0].subheadingOne_discription}
          </Typography>
        </div>
      </div>
      <div>
        <p className="text_size archivo"></p>

        {/* TipOne */}

        <div className="tips mt-3">
          <div id="border_line"></div>
          <div id="tip__container" className="px-2 px-sm-4 py-4">
            <div className="px-3 py-2">
              <div className="d-flexflex-row gap-2 align-items-center">
                <img
                  src={tongueOut}
                  alt="minemi tip image"
                  style={{ width: 30, height: 30 }}
                />
                <Typography
                  sx={{
                    fontSize: 16,
                    lineHeight: "24px",
                    letterSpacing: "0.08px",
                    color: "#59266D",
                    // color: "yellow",
                    fontFamily: "'Archivo', sans-serif",
                  }}
                >
                  MinEmi Tip
                </Typography>
              </div>
              <div className="mt-2">
                <Typography
                  sx={{
                    fontSize: 16,
                    lineHeight: "24px",
                    letterSpacing: "0.08px",
                    color: "#1F1F1F",
                    // color: "#f8f8f8",

                    fontFamily: "'Archivo', sans-serif",
                  }}
                >
                  {resultContent[0].tipOne}
                </Typography>
              </div>
            </div>
          </div>
        </div>
        <Typography
          sx={{
            fontFamily: "'Archivo', sans-serif",

            fontSize: "16px",
            padding: "1rem 0",
          }}
        >
          <strong>2. {resultContent[0].subheadTwo}</strong>
          {resultContent[0].subheadTwo_description}
        </Typography>
      </div>
    </>
  );
};

export default CalculatorResults;
